module.exports = __webpack_public_path__ + "static/kreston-shirley-4bf69f2a9374410d1985c02d01949187.jpg";